import _ from 'lodash';
import qwPartners from '../common/clients/qwPartners';

const initialState = [];
const RECEIVE = 'shippingTypes/RECEIVE';

export function loadShippingTypes() {
  return (dispatch) => {
    return qwPartners
      .get('/v1/shipping-types')
      .then((response) => response.data)
      .then((response) =>
        _.sortBy(_.take(response, response.length - 1), 'name').concat(
          _.last(response),
        ),
      )
      .then((shippingTypes) => dispatch(receiveShippingTypes(shippingTypes)));
  };
}

export function receiveShippingTypes(shippingTypes) {
  return { type: RECEIVE, payload: shippingTypes };
}

export default function reducer(state = initialState, action) {
  let { type, payload } = action;
  switch (type) {
    case RECEIVE:
      return payload;

    default:
      return state;
  }
}
